export default __webpack_public_path__ + "static/media/my-parish-app.icon.0a3f8eee.svg";